import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { InicioComponent } from "./components/visitor/inicio/inicio.component";
import { CadastroComponent } from "./components/visitor/cadastro/cadastro.component";
import { VisitorGuard } from "./guards/visitor.guard";
import { UserGuard } from "./guards/user.guard";
import { MainComponent } from "./components/logado/main/main.component";
import { EsqueciSenhaComponent } from "./components/visitor/esqueci-senha/esqueci-senha.component";
import { NotFoundPageComponent } from "./components/not-found-page/not-found-page.component";

const routes: Routes = [
	{
		path: 'cadastro',
		pathMatch: 'full',
		component: CadastroComponent,
		canActivate: [VisitorGuard],
	},
	{
		path: 'cadastro/:id/:filePerfil/:fileDoc/:fileCrp',
		pathMatch: 'full',
		component: CadastroComponent,
		canActivate: [VisitorGuard],
	},
	{
		path: 'esquecisenha',
		pathMatch: 'full',
		component: EsqueciSenhaComponent,
		canActivate: [VisitorGuard],
	},
	{
		path: 'logado',
		pathMatch: 'full',
		component: MainComponent,
		canActivate: [UserGuard]
	},
	{
		path: 'logado/:page',
		pathMatch: 'full',
		component: MainComponent,
		canActivate: [UserGuard],
	},
	{
		path: 'logado/:page/:codigo',
		pathMatch: 'full',
		component: MainComponent,
		canActivate: [UserGuard],
	},
	{
		path: 'logado/:page/:object/:id',
		pathMatch: 'full',
		component: MainComponent,
		canActivate: [UserGuard],
	},
	{
		path: '',
		pathMatch: 'full',
		component: InicioComponent,
		canActivate: [VisitorGuard]
	},
	{
		path: '**',
		pathMatch: 'full',
		component: NotFoundPageComponent
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
